import { useEffect, useState } from 'react';
import HeadingWithDescription from '../../../components/headingWithDescription';
import { Box, Stack, Typography } from '@mui/material';
import { AccountInformation } from '../../../types/manageAccount.type';
import ActivityIndicator from '../../../components/activityIndicator';
import ManageAccountService from '../../../services/manageAccount.service';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { PRIMARY_COLOR } from '../../../constants';

const InformationTile = ({ title, value }: { title: string; value: string }) => {
  return (
    <Box bgcolor={'white'} p={1} borderRadius={2} border={'1px solid black'}>
      <Typography variant="caption" color={PRIMARY_COLOR}>
        {title}
      </Typography>
      <Typography>{value.trim().length ? value : '-'}</Typography>
    </Box>
  );
};

export default function PersonalInfo() {
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState<AccountInformation | null>(null);
  const user_rcn = useSelector((state: RootState) => state.auth.userId);
  const token = useSelector((state: RootState) => state.auth.token);
  const getUserInformation = async (rcn: string) => {
    try {
      if (!token || !rcn) return;
      setLoading(true);
      let res = await ManageAccountService.getAccountInfoAsync(rcn, token);
      setUserInfo(res);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user_rcn) {
      getUserInformation(user_rcn);
    }
    // eslint-disable-next-line
  }, [user_rcn]);

  return (
    <Box p={2} bgcolor={'#f7f7f7'} minHeight={'100vh'}>
      {loading && <ActivityIndicator />}
      <HeadingWithDescription
        heading="Personal Info"
        description="You can view your personal info"
      />
      {!loading && (
        <Stack mt={4} gap={2}>
          <InformationTile title="Customer Code" value={userInfo?.cust_code ?? ''} />
          <InformationTile
            title="Full name"
            value={`${userInfo?.first_name ?? ''} ${userInfo?.last_name ?? ''} `}
          />
          <InformationTile title="Mobile" value={`${userInfo?.rcn ?? ''}`} />
          <InformationTile title="Alternate mobile" value={`${userInfo?.alterno ?? ''}`} />
          <InformationTile title="Email" value={userInfo?.email ?? ''} />
        </Stack>
      )}
    </Box>
  );
}
